import React from "react";
import teamImage from "../../assets/team.webp";
import visionImage from "../../assets/vision.webp";
import missionImage from "../../assets/mission.webp";
import trustIcon from "../../assets/sol-c2pa-ic-trust.svg";
import verifiedIcon from "../../assets/icon-verified-gold.svg";
import secureIcon from "../../assets/icon-secure.svg";
import borderlessIcon from "../../assets/icon-sol-borderless.svg";
import { useNavigate } from "react-router-dom";
import HeaderAny from "../header";
import MobileNav from "../header-mobile";
import AuthenticityBanner from "../../pages/authenticity_banner.jsx";


const principles = [
    {
        number: '01',
        icon: trustIcon,
        iconColor: 'var(--color-primary)',
        title: 'Trust should be earned, not assumed.',
        description: 'A record is only worth as much as your ability to check it. We build for the moment someone asks, "how do you know?" — and can answer with evidence instead of assurance.'
    },
    {
        number: '02',
        icon: verifiedIcon,
        iconColor: '#FABB18',
        title: 'Good work deserves proof.',
        description: "Professionals should be credited for what they've actually built. A verifiable track record is the fairest currency in this industry — and the one hardest to fake."
    },
    {
        number: '03',
        icon: secureIcon,
        iconColor: 'var(--color-primary)',
        title: 'Data sovereignty by design.',
        description: 'Construction and verification data belongs to the people and institutions it documents — not to ConRa. You decide who can access each record and on what terms, so ownership and control never quietly transfer to the platform holding it.'
    },
    {
        number: '04',
        icon: borderlessIcon,
        iconColor: 'var(--color-primary)',
        title: "Proof shouldn't be locked to one platform.",
        description: "We align with open standards like C2PA so a record holds up no matter who's checking it — including long after a project, or a vendor relationship, is done."
    }
];

const AboutCentria = () => {
    const navigate = useNavigate();
    const handleExploreFeatures = () => {
        navigate("/feature", { state: { feat: "ConRa" } });
    };
    return (
        <div>
            <div>
                <div className="web-only">
                    <HeaderAny />
                </div>
                <div className="mobile-only">
                    <MobileNav />
                </div>
            </div>
            <div className="about-wrapper">

                <section className="about-section">
                    <div className="about-text">
                        <h1 className="h1-48-600"><span >About</span> ConRa</h1>
                        <p>
                            ConRa bridges trust in the global built environment by creating
                            verified digital records of how projects are delivered. Construction
                            brings together multiple stakeholders — developers, owners,
                            contractors, architects, engineers, consultants, government agencies,
                            NGOs, financial institutions, and investors — all relying on accurate
                            information to understand project activity and progress. Yet this
                            information is often fragmented across photographs, reports,
                            documents, and updates, making it difficult to verify what happened,
                            when, and where. ConRa captures evidence at its source and preserves
                            its context through location, time, cryptographic signatures, and C2PA
                            content provenance, transforming project records into a continuous,
                            tamper-evident digital audit trail even for decades. The result is a
                            trusted project history that enables stakeholders to verify progress,
                            strengthen accountability, reduce uncertainty, and make informed
                            decisions throughout the project lifecycle.
                        </p>
                    </div>
                    <div className="about-image">
                        <img src={teamImage} alt="Team meeting" />
                    </div>
                </section>


                {/* <section className="about-section">
                    <div className="about-image-reverse">
                        <img src={missionImage} alt="Team meeting" />
                    </div>
                    <div className="about-text">
                        <h1 className="h1-48-600">Our <span >Mission</span></h1>
                        <p>
                            ConRa equips construction leaders and project owners to produce tamper-evident proof of work and build a verifiable global reputation, from concept to completion.
                        </p>
                    </div>
                </section>


                <section className="about-section">
                    <div className="about-text">
                        <h1 className="h1-48-600">Our <span >Vision</span></h1>
                        <p>
                            Around the verified record sits a corporate identity system that turns a professional's body of work into something they own. Every verified project becomes part of a portfolio that stands on its own evidence — credible to clients, lenders, and institutional partners anywhere, and discoverable in the global markets where the next opportunity lives. For the developers and design professionals shaping tomorrow's built environment, what you build becomes proof of what you can build.

                            Every other portfolio shows images. ConRa shows proof.
                        </p>
                    </div>
                    <div className="about-image">
                        <img src={visionImage} alt="Team meeting" />
                    </div>
                </section> */}

                <section className="principles-section">
                    {/* <p className="principles-eyebrow">— WHAT WE BELIEVE</p> */}
                    <h2 className="h1-48-600">Principles we build on.</h2>
                    <div className="principles-grid">
                        {principles.map((principle) => (
                            <div className="principles-card" key={principle.number}>
                                <div className="principles-card-header">
                                    <div
                                        className="principles-icon"
                                        style={{ backgroundColor: `${principle.iconColor}1A` }}
                                    >
                                        <img src={principle.icon} alt="" />
                                    </div>
                                    <span className="principles-number">{principle.number}</span>
                                </div>
                                <h3 className="principles-title">{principle.title}</h3>
                                <p className="principles-desc">{principle.description}</p>
                            </div>
                        ))}
                    </div>
                </section>


                <AuthenticityBanner />

                {/* <section className="about-choice-section">
                    <div className="column">
                        <h2 className="h1-48-600">Ready to <span>Streamline</span> Your Projects ?</h2>
                        <p className="grey-text">
                            See how ConRa can transform your construction projects. Schedule a personalized demo with our team today
                        </p>
                        <div className="faq-container">
                            <button className="filled-button" onClick={() => handleExploreFeatures()}>Request Demo</button>
                        </div>
                    </div>
                </section> */}
            </div>
        </div>
    );
};

export default AboutCentria;
